module.exports = __webpack_public_path__ + "img/content.d2432110.png";